(ns teamoesterreich.admin-mode.lebensretter.opt-in.list
  (:require [clojure.string :as str]
            [clojure.string]
            [reagent-material-ui.components :as mui]
            [reagent.core :as r]
            [teamoesterreich.admin-mode.data.user :as d-user]
            [teamoesterreich.admin-mode.lebensretter.opt-in.sort-table :as table]
            [teamoesterreich.admin-mode.static-data :as staticData]
            [teamoesterreich.util.helper :as h]
            [teamoesterreich.view-state :as vstate]))

(defn event-value
  [^js/Event e]
  (h/event-value e))

(defn get-list [!elms !loaded !invalidated]
  (reset! !invalidated false)
  (d-user/get-user-list-lebensretter-optIn
    (fn [data]
      (reset! !elms data)
      (reset! !loaded true)
      )))

(defonce DST_LIST staticData/DST_LIST)
(defonce DEP_LIST staticData/DEP_LIST)

(defn filter-rows [elms search]
  (filterv (fn [elm]
             (some (fn [value]
                     (str/includes? (str/lower-case (str value)) (str/lower-case (str/trim (str search)))))
                   (vals elm)))
           elms))

(defn table-column [!st !search]
  (let [!elms (r/cursor !st [:data])
        rows (filter-rows @!elms @!search)]
    (if (pos? (count rows))
      [(table/table !st rows)]
      [:h3 "Keine Ergebnisse gefunden!"])
    ))

(defn search-field [!search !waiting? !invalidated]
  [mui/text-field
   {:default-value (str @!search)
    :placeholder   "suche..."
    :style         {:float     "left" :margin "5px 5px 5px 25px" :display "inline-block" :width "300px"
                    :textAlign "left"}
    :onChange      (h/wait-do !waiting? (fn [val]
                                          (reset! !search val)
                                          (reset! !invalidated true)))
    :multiline     false}])

(defn render-table []
  (let [!st (r/cursor vstate/app-state [:lr-optIn-list])
        !elms (r/cursor vstate/app-state [:lr-optIn-list :data])
        !invalidated (r/cursor vstate/app-state [:lr-optIn-list :invalidated])
        !loaded (r/cursor vstate/app-state [:lr-optIn-list :loaded])
        !waiting? (r/cursor !st [:waiting])
        !search (r/cursor vstate/app-state [:lr-optIn-list :search])
        ]

    (fn []
      [:div {:style {:display "flex" :flexDirection "column" :align-items "stretch" :height "100%" :marginTop "20px"}}


       [mui/typography {:variant "h5" :style {:margin "7px 0 0 0"}}
        "Lebensretter Opt-In"]
       [mui/grid
        {:container     true
         :direction     "row"
         :alignItems    "stretch"
         :justify       "flex-start"
         :spacing       0
         :columnSpacing 0
         }

        (when (true? @!invalidated) (get-list !elms !loaded !invalidated) "")
        ]

       [search-field !search !waiting? !invalidated]

       (if-not @!loaded
         (do
           (get-list !elms !loaded !invalidated)
           [:div
            [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40 :style {:marginTop "40px"}}]
            [mui/typography {} "Lade Daten ... "]
            ]
           )
         [:div
          {:style {:background-color "white" :flex "10 10 250px"}}
          [table-column !st !search]
          ]

         )
       ]

      )))

(defn get-it []
  [(render-table)])